import { useContext } from 'react'
import { AppContext } from '../contexts'
import { toLatLng, formatContact } from '../utils'
import useAppointmentDetails from './useAppointmentDetails'
import useDateTime from './useDateTime'

// Everything the task pages (details and review) show about one task
function useTask(taskId) {
  const { formatDateTime } = useDateTime();
  const { appointmentData = {}, tasks, workOrder } = useContext(AppContext);
  const task = tasks.find(item => String(item.id) === String(taskId));
  const details = useAppointmentDetails(
    task?.startTimeInUTC,
    task?.endTimeInUTC,
    {
      task: task?.title,
      confirmationNumber: task?.confirmationNumber,
      address: workOrder.address,
      subcontractor: formatContact(task?.subcontractorName, task?.subcontractorPhone),
      technician: task?.assigneeName
    }
  );
  // Backend sends the step time as logDate
  const steps = (task?.steps || []).map(step => {
    const time = step.subTitle || step.logDate;
    return { ...step, subTitle: time ? formatDateTime(time) : undefined };
  });

  return {
    task,
    details,
    steps,
    mapAllowed: appointmentData.mapAllowed,
    destination: appointmentData.destination,
    // Pin the task's own site, falling back to the booking location
    origin: toLatLng(task?.site) || appointmentData.origin
  };
}

export default useTask
